'use client';

import { useState } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import LeadCaptureModal from '@/components/common/LeadCaptureModal';
import ProductCategories from './components/ProductCategories';
import TechnicalAdvantages from './components/TechnicalAdvantages';
import IntegrationProcess from './components/IntegrationProcess';
import CustomFormulations from './components/CustomFormulations';

interface ModalState {
  isOpen: boolean;
  resourceId: string;
  documentType: string;
  buttonText: string;
}

export default function ServicesPage() {
  const [modalState, setModalState] = useState<ModalState>({
    isOpen: false,
    resourceId: '',
    documentType: '',
    buttonText: '',
  });

  const openModal = (resourceId: string, documentType: string, buttonText: string) => {
    setModalState({
      isOpen: true,
      resourceId,
      documentType,
      buttonText,
    });
  };

  const closeModal = () => {
    setModalState((prev) => ({ ...prev, isOpen: false }));
  };

  return (
    <>
      <Header />
      <main id="main-content" className="pt-[var(--header-height)]">
        {/* Product Portfolio hero: dark, centred, four application cards.
              Background Product-Portfolio-bg.png (cover/center) under a navy
              overlay; cards reuse existing application data and anchor to the
              product explorer below. */}
        <section className="relative overflow-hidden bg-ink text-white">
          <div
            aria-hidden="true"
            className="absolute inset-0"
            style={{
              backgroundImage: "url('/assets/images/Product-Portfolio-bg.png')",
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
          <div aria-hidden="true" className="absolute inset-0 bg-ink/55 sm:bg-ink/40" />

          <div className="container-page relative py-16 lg:py-24">
            <div className="mx-auto max-w-5xl text-center">
              <p className="rise inline-flex h-10 items-center rounded-full border border-accent/40 bg-accent/10 px-5 text-[0.8125rem] font-semibold uppercase tracking-[0.16em] text-accent">
                Product Portfolio
              </p>

              <h1
                className="rise delay-1 mt-5 font-bold text-white"
                style={{
                  fontSize: 'clamp(2rem, 0.8rem + 3.7vw, 4.25rem)',
                  lineHeight: 1.08,
                  letterSpacing: '-0.02em',
                }}
              >
                <span className="block">Graphene Additives</span>
                <span className="block sm:whitespace-nowrap">Engineered for Your Industry</span>
              </h1>

              <div
                aria-hidden="true"
                className="rise delay-2 mx-auto mt-5 h-[2px] w-28 rounded-full bg-gradient-to-r from-transparent via-accent to-transparent shadow-[0_0_14px_rgba(14,165,233,0.5)]"
              />

              <p className="rise delay-2 mx-auto mt-6 max-w-2xl text-[1.0625rem] leading-relaxed text-slate-300 sm:text-lg">
                Tailored solutions for lubricants, concrete, composites, and rubber applications
                with comprehensive technical support.
              </p>
            </div>
          </div>
        </section>

        <ProductCategories
          onDownloadTDS={(resourceId, productName) =>
            openModal(resourceId, productName.replace(' Technical Data Sheet', ''), 'Download TDS')
          }
        />
        <TechnicalAdvantages />
        <IntegrationProcess />
        <CustomFormulations />
      </main>

      {/* Lead Capture Modal */}
      <LeadCaptureModal
        isOpen={modalState.isOpen}
        onClose={closeModal}
        resourceId={modalState.resourceId}
        buttonText={modalState.buttonText}
        modalTitle={`Download ${modalState.documentType}`}
        modalDescription={`Enter your details to download our ${modalState.documentType.toLowerCase()}`}
        successMessage={`Thank You! Your ${modalState.documentType} is downloading...`}
      />

      <Footer />
    </>
  );
}
